<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="w-100" style="text-align: center;">
    <l-map
      ref="cluMap"
      class="map"
      :center="center"
      :zoom="zoom"
      :minZoom="minZoom"
      :maxZoom="maxZoom"
      :max-bounds="maxBounds"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-geo-json :geojson="geojson" :options-style="styleFunction" />
      <l-marker @click="openModal(marker)" v-for="marker in markers" :key="marker.id" :lat-lng="marker.coordonnees">
        <l-icon
          :icon-size="dynamicSize(marker.size)"
          :icon-anchor="dynamicAnchor(marker.size)"
          :icon-url="marker.iconurl"
        />
      </l-marker>
      <l-control position="bottomleft">
        <div @click="OpenObjects" class="sac">
          <img src="https://cdn.exploreve.fr/content/sac_a_dos/sac_a_dos.svg" alt />
        </div>
      </l-control>
    </l-map>
    <ModalCluedo
      @recupObject="getRecupObject"
      @audio="reemitMusic"
      :open="modalSwitch"
      :currentModal="currentModal"
      :objects="Objects"
    ></ModalCluedo>
    <ModalObjects :open="modalObjects" :objects="Objects"></ModalObjects>
    <RulesModal :open="modealRules"></RulesModal>
  </div>
</template>

<script>
// @ is an alias to /src
import { latLngBounds } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon, LGeoJson, LControl } from "vue2-leaflet";
import json from "./markers.json";
import ModalCluedo from "@/components/immersion02/Cluedo/ModalCluedo.vue";
import ModalObjects from "@/components/immersion02/Cluedo/ModalObjects.vue";
import RulesModal from "@/components/immersion02/Cluedo/RulesModal.vue";

export default {
  name: "IM_2_1",
  data: function () {
    return {
      Objects: [
        { name: "corde", label: "Corde de 18m", recover: false, icon: "/content/cluedo/corde.svg" },
        { name: "propane", label: "Propane liquide", recover: false, icon: "/content/cluedo/Fioles/fiole_2.svg" },
        { name: "tissu", label: "6m2 de tissu", recover: false, icon: "/content/cluedo/Tissus-plié.svg" },
        { name: "sextant", label: "Un sextant", recover: false, icon: "/content/cluedo/Sextan.svg" },
        {
          name: "boiteAoutils",
          label: "Une boite à outils ",
          recover: false,
          icon: "/content/cluedo/caisse a outils.svg"
        },
        { name: "bruleur", label: "Un bruleur qui fonctionne", recover: false, icon: "/content/cluedo/Bruleur.svg" },
        { name: "ancre", label: "Une ancre pour amarrer le ballon", recover: false, icon: "/content/cluedo/Ancre.svg" },
        { name: "lettre", label: "La lettre", recover: false, icon: "/content/cluedo/lettre v2.svg" },
        { name: "piqure", label: "Piqures de chenille", recover: false, icon: "", hidden: true }
      ],
      mecanicienne_seen: false,
      currentModal: null,
      modalSwitch: false,
      modalObjects: false,
      id: 2,
      url: "https://cdn.exploreve.fr/tiles/{z}/{x}/{y}.png",
      attribution: `Fond de carte : &copy; <a href="https://www.thunderforest.com/">Thunderforest</a>, Données : &copy; les contributeurs d'<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>`,
      zoom: 15,
      currentZoom: 15,
      minZoom: 13,
      maxZoom: 17,
      center: [49.0666, 1.6601],
      maxBounds: latLngBounds([
        [49.130703841205346, 1.8114073309853063],
        [48.98359763736411, 1.428826078438522]
      ]),
      markers: json,
      geojson: null,
      modealRules: false
    };
  },
  methods: {
    getRecupObject: function (object) {
      this.Objects.find((obj) => obj.name === object).recover = true;
    },
    OpenObjects: function () {
      this.modalObjects = !this.modalObjects;
    },
    openRules: function () {
      this.modealRules = !this.modealRules;
    },
    closeModal: function () {
      this.modalSwitch = !this.modalSwitch;
    },
    openModal: function (marker) {
      if (marker) {
        this.currentModal = marker;
        this.modalSwitch = !this.modalSwitch;
      }
    },
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    },
    reemitMusic: function (event) {
      this.$emit("audio", event);
    },
    zoomUpdate: function (zoom) {
      this.currentZoom = zoom;
    },
    dynamicSize: function (size) {
      var initzoom = 15;
      var a = (Math.pow(2, this.currentZoom) * size) / Math.pow(2, initzoom);
      return [a, a];
    },
    dynamicAnchor: function (size) {
      var initzoom = 15;
      var a = (Math.pow(2, this.currentZoom) * size) / Math.pow(2, initzoom);
      return [a / 2, a];
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LControl,
    LGeoJson,
    ModalCluedo,
    ModalObjects,
    RulesModal
  },
  async created() {
    const response = await fetch("https://cdn.exploreve.fr/content/cluedo/moisson.geojson");
    this.geojson = await response.json();
    this.emitMusic("play", "musiccluedo");
    this.openRules();
  },
  computed: {
    styleFunction() {
      return () => {
        return {
          color: "#CD8C31",
          dashArray: "20 15",
          opacity: 1,
          fillOpacity: 0
        };
      };
    }
  }
};
</script>

<style scoped lang="scss">
.sac {
  position: absolute;
  margin: 15px;
  bottom: 15px;
  left: 15px;
  cursor: pointer;
  img {
    height: 10vh;
  }
}

.map {
  position: absolute;
  top: 6vh;
  left: 0;
  width: 100vw;
  height: 94vh;
  margin: 0;
  padding: 0;
  z-index: 0;
}
</style>
